import { useState, useEffect } from 'react';

export default function useHideCompletedPreference(storageKey, defaultValue = true) {
  const [hideCompleted, setHideCompletedState] = useState(defaultValue);

  useEffect(() => {
    if (!storageKey) {
      setHideCompletedState(defaultValue);
      return;
    }
    const saved = localStorage.getItem(storageKey);
    if (saved === 'true' || saved === 'false') {
      setHideCompletedState(saved === 'true');
    } else {
      setHideCompletedState(defaultValue);
    }
  }, [storageKey, defaultValue]);

  const setHideCompleted = (value) => {
    const next = typeof value === 'function' ? value(hideCompleted) : value;
    setHideCompletedState(next);
    if (storageKey) {
      localStorage.setItem(storageKey, next ? 'true' : 'false');
    }
  };

  return [hideCompleted, setHideCompleted];
}
